// Parser for the copy-carrossel artifact (Epic 16.2). The agent emits markdown
// with one "## Card N — Título" heading per card (1..6) plus a final
// "## Legenda" section. Headings tolerate emoji/extra spaces and any dash or
// colon separator. Returns null when fewer than 2 cards are found so callers
// can fall back to plain markdown rendering.
const CARD_RE = /^#{2,6}\s*(?:[^A-Za-z0-9\n]*\s*)?card\s*0*(\d+)\s*[—–\-:·.]?\s*(.*)$/i;
const LEGENDA_RE = /^#{2,6}\s*(?:[^A-Za-z0-9\n]*\s*)?legenda\b/i;

export function parseCarousel(content) {
  if (!content || typeof content !== "string") return null;
  const lines = content.split(/\r?\n/);
  const cards = [];
  let legenda = null;
  let current = null;
  for (const line of lines) {
    const cardMatch = line.match(CARD_RE);
    if (cardMatch) {
      const card = { n: parseInt(cardMatch[1], 10), title: cardMatch[2].trim(), body: [] };
      cards.push(card);
      current = card.body;
      continue;
    }
    if (LEGENDA_RE.test(line)) {
      legenda = [];
      current = legenda;
      continue;
    }
    if (current) current.push(line);
  }
  if (cards.length < 2) return null;
  return {
    cards: cards.map((c) => ({ n: c.n, title: c.title, body: c.body.join("\n").trim() })),
    legenda: legenda ? legenda.join("\n").trim() : "",
  };
}
